const isArtwork = category => category === "digital-art" || category === "digital-twin-art";

// Credit belongs to the asset, independently of its owner or an artwork's author.
export function buildAssetDetails({ metadata = {}, assetCategory, attributionName = "", tags = [] } = {}) {
  const nextMetadata = { ...metadata };
  const attribution = { ...metadata.attribution };
  const name = typeof attributionName === "string" ? attributionName.trim() : "";
  if (isArtwork(assetCategory)) {
    // The credit field is hidden for artwork; preserve any existing credit verbatim.
  } else if (name) {
    attribution.name = name;
  } else if (Object.prototype.hasOwnProperty.call(attribution, "name")) {
    // Metadata updates deep-merge: omission would retain the stored name.
    attribution.name = "";
  }
  if (Object.keys(attribution).length > 0) {
    nextMetadata.attribution = attribution;
  } else {
    delete nextMetadata.attribution;
  }
  return {
    metadata: nextMetadata,
    tags: Array.isArray(tags)
      ? [
          ...new Set(
            tags
              .filter(tag => typeof tag === "string")
              .map(tag => tag.trim())
              .filter(Boolean)
          )
        ]
      : []
  };
}

export function readAssetDetails(asset = {}) {
  return {
    attributionName: asset.metadata?.attribution?.name || "",
    tags: Array.isArray(asset.tags) ? asset.tags.filter(tag => typeof tag === "string") : []
  };
}
